import CLASS_NAMES from '@js/constants/css-constants.es6.js';

export default class ContentUtils {
  /**
   * Decoded an encoded HTML string, while preserving tags.
   *
   * Example input: <span>1 &#43; &#40;2&#42;3&#41; &#61; 7</span>
   * Example output: <span>1 + (2*3) = 7</span>
   *
   * @param {string} html the encoded html string
   * @return {string} the decoded html string
   */
  static decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  /**
   * Generate an ID for a given Drupal machine name (replace underscores with dashes).
   * @param {string} machineName the machine name for the Drupal content type
   * @return {string} the ID associated with the machine name
   */
  static machineNameToId(machineName) {
    return machineName.replaceAll('_', '-').toLowerCase();
  }

  /**
   * Generate the class name for a Drupal content type machine name.
   *
   * @param {string} machineName the machine name for the Drupal content type
   * @return {string} the class name the Drupal content type should render with
   */
  static contentTypeMachineNameToClassName(machineName) {
    const id = ContentUtils.machineNameToId(machineName);
    return `${CLASS_NAMES.CONTENT_TYPE_PREFIX}${id}`;
  }

  /**
   * Generate the class name for a Drupal field machine name.
   *
   * @param {string} machineName the machine name for the Drupal field
   * @return {string} the class name the Drupal field should render with
   */
  static fieldMachineNameToClassName(machineName) {
    const id = ContentUtils.machineNameToId(machineName);
    return `${CLASS_NAMES.FIELD_PREFIX}${id}`;
  }

  /**
   * Generate the class name for a Drupal paragraph machine name.
   *
   * @param {string} machineName the machine name for the Drupal field
   * @return {string} the class name the Drupal field should render with
   */
  static paragraphMachineNameToClassName(machineName) {
    const id = ContentUtils.machineNameToId(machineName);
    return `${CLASS_NAMES.PARAGRAPH_PREFIX}${id}`;
  }
}
